import apiClient from '../apiClient';
import { PUT_ACCOMODATION_URL } from '../apiUrl';

const putAccomodationApi = (id, data) => {
  return apiClient.put(PUT_ACCOMODATION_URL(id), data);
};

export default putAccomodationApi;
